import { Router } from '@vaadin/router';
import * as util from 'lib/util.js'
import { LitElement,  TemplateResult, property, customElement, css } from 'lit-element';
import {html, render} from 'lit-html';
import {unsafeHTML} from 'lit-html/directives/unsafe-html.js';
import {storeInstance} from "store/index.js";
import '@vaadin/vaadin-icons/vaadin-icons.js';
import "@ui5/webcomponents/dist/Panel";
import "./kb-comment-form"
import "./kb-comment-update-form.js";
import "@ui5/webcomponents/dist/Button";

class KbCommentLayout extends (LitElement)   {
    constructor(){
        super();
       }    

    connectedCallback(){
        this.subscription = storeInstance.subscribe(state => {
            this.stateChange(state);
            });
        this.state = storeInstance.state
        this.string = this.state.strings;
        PubSub.subscribe("commentupdated", this._commentUpdated.bind(this));
        this.collapsed=true;
        this.numComments="0";
        this.comments=[];
        this.dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        if(this.state.comment_permissions){
            if(this.state.comment_permissions.group.includes("R") || this.state.comment_permissions.owner.includes("R")){
                this.myRender()
                }
           }
        }

     
    disconnectedCallback() {
        storeInstance.unsubscribe(this.subscription)
        }

    refresh(){
        storeInstance.dispatch("getComments", this.kbrid);
        }

    stateChange(state){
        this.state = state;
        this.string = this.state.strings;
        if(this.state.topic_comments){
            this.numComments = this.state.topic_comments.length;
            this.comments = this.state.topic_comments;
        } else {
            this.numComments="0";
            this.comments=[];
            }
        if(this.state.comment_permissions){
            if(this.state.comment_permissions.group.includes("R") || this.state.comment_permissions.owner.includes("R")){
                this.myRender()
                }
            }
        }

    myRender(){
        render(this.template(), this.shadowRoot);
        }

    formatDate(inDate){
        return util.formatDate(inDate);
        }
    
    _canCreate(){return this.state.comment_permissions.group.includes("C") || this.state.comment_permissions.owner.includes("C")}
    _canEditAll(){return this.state.comment_permissions.group.includes("U")}
    _canEditOwn(){return this.state.comment_permissions.owner.includes("U")}
    _canDelAll(){return this.state.comment_permissions.group.includes("D")}
    _canDelOwn(){return this.state.comment_permissions.owner.includes("D")}

    _commentUpdated(){
        var updateEditor = this.shadowRoot.querySelector("#updateeditor");
        updateEditor.parentElement.innerText = updateEditor.text;
        updateEditor.remove();
        this.editoropen=false;
    }

    template(){
       return html`
            <style>
                #iconspan{
                    display:inline-block;width:20px;
                }
                .comment{
                    margin-bottom: 2rem;
                    margin-left:2rem;
                    padding-top:1rem;
                    border-top: 1px solid grey;
                    }                
                .username{
                    font-weight:bold;
                    }
                .commentdate{
                    font-size:70%;
                    font-style: italic;
                    margin-left: 0.5rem
                    }
                .commenttext{
                    margin-top:.75rem;
                    }
                .icons{
                    float: right;
                }
                ui5-panel {
                    --_ui5_panel_content_padding: 0;
                }
            </style>
            <ui5-panel id='comments' width="100%" ?collapsed="${this.collapsed}" accessible-role="Complementary" header-text="${this.numComments} ${Number(this.numComments) === 1 ? this.string["_comments_layout_heading"] : this.string["_comments_layout_heading_plural"]}" class="full-width">
                
                ${this.comments.map((comment) => 
                    html` 
                        <div class='comment'>
                            <div style="display: flex; align-items: center;">
                                <div class='username'>${comment.kbUserName}</div>
                                <div class='commentdate'>${this.formatDate(comment.date)} </div>
                            </div>
       
                            <div class="icons">
                                ${this._editButtonTemplate(comment)}
                                ${this._delButtonTemplate(comment)}            
                            
                            </div>
                            <div class='commenttext'>${this._formatComment(comment.text)}</div>
                        </div>`
                    )}
                ${this._commentFormTemplate()}
            </ui5-panel>
           `;
        }
    
    _editButtonTemplate(comment){
        if(this._canEditAll() || this._canEditOwn() && this.state.kb_user.username == comment.kbUserName){
            return html`<ui5-button icon="edit" title="${this.string["_editcomment"]}"  id="${comment.tcCommentId}" @click="${this.editComment.bind(this)}"></ui5-button>`;    
            }
        }

    _delButtonTemplate(comment){
        if(this._canDelAll() || this._canDelOwn() && this.state.kb_user.username == comment.kbUserName){
            return html`<ui5-button id="${comment.tcCommentId}" @click="${this.deleteComment.bind(this)}">${this.string["_deletecomment"]}</ui5-button>`;
            }
        }

    _commentFormTemplate(){
        if(this._canCreate()){
            return html`<kb-comment-form .kbrid="${this.kbrid}"></kb-comment-form>`;
            }
        }

    _formatComment(val){
        var encodedStr = val.replace(/[\u00A0-\u9999<>\&]/g, function(i) {
            return '&#'+i.charCodeAt(0)+';';
         });
        return unsafeHTML(encodedStr.split('\n').join('<br>'));
        }

    deleteComment(e){
        storeInstance.dispatch("deleteComment", {kbrid: this.kbrid, commentid: e.currentTarget.id});
    }
    editComment(e){
        var commentDiv = e.currentTarget.parentElement.parentElement.children[e.currentTarget.parentElement.parentElement.children.length-1];
        var editor= document.createElement("kb-comment-update-form");
        editor.id='updateeditor';
        editor.kbrid = this.kbrid;
        editor.commentid = e.currentTarget.id;
        editor.comment = commentDiv.innerText;
        if(!this.editoropen) {
            commentDiv.appendChild(editor)
            this.editoropen=true;
        } else {
            this.editoropen=false;
            this.shadowRoot.querySelector("#updateeditor").remove();
        }
    }
}

customElements.define('kb-comment-layout', KbCommentLayout)
